import * as React from "react";

const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    className="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-4uxqju-MuiSvgIcon-root"
    data-testid="ScheduleIcon"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M10.75 3.25v-.971c0-.094.097-.175.237-.198a6.354 6.354 0 0 1 2.026 0c.14.023.237.104.237.198v.97zm-5.62 12.5L5.125 17c.562 0 .871-.126 1.212-.265.418-.17.883-.36 1.914-.36 1.033 0 1.685.379 2.273.72.478.278.915.53 1.476.53.563 0 .998-.252 1.479-.53.587-.341 1.242-.72 2.274-.72 1.03 0 1.495.19 1.912.36.34.139.649.265 1.21.265v-1.25c.003 0 1.103-2.491 1.619-3.659a.624.624 0 0 0-.341-.831l-1.278-.51V6.375a2.5 2.5 0 0 0-2.5-2.5H7.627a2.5 2.5 0 0 0-2.5 2.499l-.002 4.376-1.274.51a.625.625 0 0 0-.339.832zm1.787 5.46c-.673.385-1.512.79-3.042.79H2v-2.5h1.875c.97 0 1.381-.22 1.801-.46l.119-.069c.529-.306 1.245-.72 2.455-.72 1.312 0 2.037.48 2.569.834l.005.004c.403.269.617.411 1.176.411.57 0 .809-.15 1.225-.422l.025-.017c.518-.337 1.243-.81 2.5-.81 1.16 0 1.879.41 2.395.705l.138.08c.432.242.867.464 1.842.464H22V22h-1.875c-1.525 0-2.382-.402-3.065-.785l-.125-.07c-.495-.279-.7-.395-1.185-.395-.512 0-.721.136-1.16.423-.544.353-1.285.827-2.59.827-1.313 0-2.038-.481-2.569-.835l-.005-.004c-.404-.268-.617-.41-1.176-.41-.531 0-.748.124-1.225.398l-.108.062zM17 5.75H7v4.375l5-1.875 5 1.875Z"
      clipRule="evenodd"
      style={{
        strokeWidth: 1.25002,
      }}
    />
  </svg>
);

export default SvgComponent;
